import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { useWindowSize } from 'modules/core';
import NavBarMobile from './NavBarMobile';
import { Logo } from '../Logo';

import styles from './NavBar.module.scss';

function NavBar({
  className,
  showLogo = true,
  light,
  lightLogo = !light,
  children,
  containerClassName,
  showMobile = true,
  ...otherProps
}) {
  const classes = classNames(styles.navBar, light && styles.light, className);
  const { size, desktopWidth } = useWindowSize();

  if (desktopWidth || !size || !showMobile)
    return (
      <div className={classes}>
        <div>
          {showLogo && (
            <Link
              to="https://www.ahabtalent.com/"
              aria-label="Ahab Talent Home"
            >
              <Logo dark={!lightLogo} />
            </Link>
          )}
        </div>
        <div className={classNames(styles.navigationLinks, containerClassName)}>
          {children}
        </div>
      </div>
    );
  return <NavBarMobile {...otherProps}>{children}</NavBarMobile>;
}

export default memo(NavBar);
